import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const pointerProFormSelector = document.querySelectorAll('.es-block-forms--js-pointer-pro-form form');
	const pointerProModalSelector = document.querySelector('.js-pointer-pro-modal');

	const enhancedEcommerceFormSelector = document.querySelectorAll('.es-block-forms--js-enhanced-ecommerce form');

	const bookADemoFormSelector = document.querySelectorAll('.es-block-forms--js-book-a-demo form');

	const dropdownOverlayFormSelector = document.querySelectorAll('.es-block-forms--with-dropdown-overlay form');

	const gtmEventBookADemoSelector = document.querySelectorAll('.es-block-forms--gtm-event-book-a-demo form');
	const gtmEventTryProductiveSelector = document.querySelectorAll('.es-block-forms--gtm-event-try-productive form');

	// GTM Event Book a Demo Form
	if (gtmEventBookADemoSelector?.length) {
		const { GtmEventBookADemo } = await import('./gtm-event-book-a-demo');

		gtmEventBookADemoSelector.forEach((item) => {
			new GtmEventBookADemo({
				gtmEventBookADemoForm: item,
			}).init();
		});
	}

	// GTM Event Try Productive Form
	if (gtmEventTryProductiveSelector?.length) {
		const { GtmEventTryProductive } = await import('./gtm-event-try-productive');

		gtmEventTryProductiveSelector.forEach((item) => {
			new GtmEventTryProductive({
				gtmEventTryProductiveForm: item,
			}).init();
		});
	}

	// Dropdown Overlay Form
	if (dropdownOverlayFormSelector?.length) {
		const { DropdownOverlay } = await import('./dropdown-overlay');

		dropdownOverlayFormSelector.forEach((item) => {
			new DropdownOverlay({
				dropdownOverlayForm: item,
			}).init();
		});
	}

	// Enhanced Ecommerce Form
	if (enhancedEcommerceFormSelector?.length) {
		const { EnhancedEcommerceForm } = await import('./enhanced-ecommerce-form');

		enhancedEcommerceFormSelector.forEach((item) => {
			new EnhancedEcommerceForm({
				enhancedEcommerceForm: item,
			}).init();
		});
	}

	// Book a Demo Form
	if (bookADemoFormSelector?.length) {
		const { BookADemoForm } = await import('./book-a-demo-form');

		bookADemoFormSelector.forEach((item) => {
			new BookADemoForm({
				bookADemoForm: item,
			}).init();
		});
	}

	// Pointer Pro Form
	if (!pointerProFormSelector.length || !pointerProModalSelector) {
		return;
	}

	const { PointerProForm } = await import('./pointer-pro-form');

	pointerProFormSelector.forEach((item) => {
		new PointerProForm({
			pointerProForm: item,
		}).init();
	});
});
